import { render, staticRenderFns } from "./EventGrid.vue?vue&type=template&id=a9bc4116"
import script from "./EventGrid.vue?vue&type=script&lang=js"
export * from "./EventGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports